addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".marquee").forEach(marquee => {
    if ("infinite" in marquee.dataset) {
      const original = Array.from(marquee.children)
      for (let i = 0; i < 39; i++) {
        original.forEach(child => marquee.appendChild(child.cloneNode(true)))
      }
      if (marquee.dataset.speed) {
        marquee.dataset.speed = parseFloat(marquee.dataset.speed) * 40
      } else {
        marquee.dataset.speed = 15 * 40
      }
    }
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)
    marquee.append(div.cloneNode(true))
    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)
    if (marquee.dataset.speed) {
      marquee.dataset.marquee = Math.random()
      const style = document.createElement("style")
      style.textContent = `
        [data-marquee="${marquee.dataset.marquee}"].marquee.scrolling .marquee-sub {
          animation: marquee ${parseFloat(marquee.dataset.speed)}s linear infinite;
        }
      `
      document.body.appendChild(style)
    }
    let paused = false
    if ("pausable" in marquee.dataset) {
      const pause = () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "paused")
      const resume = () => marquee.querySelectorAll(".marquee-sub").forEach(e => e.style.animationPlayState = "running")
      marquee.addEventListener("mouseenter", pause)
      marquee.addEventListener("mouseleave", () => {
        paused = false
        resume()
      })
      marquee.addEventListener("touchstart", e => {
        paused = !paused
        if (paused) pause()
        else resume()
      })
    }
    marquee.classList.add("initialised")
    const adjust = () => marquee.classList.toggle("scrolling", measure.clientWidth > marquee.clientWidth)
    setTimeout(adjust, 0)
    window.addEventListener("resize", adjust)
  })
})